import ArtworksSlider from '../classes/ArtworksSliderClass';

const selectors = {
    el: '.js-artworks-slider:not(.is-initialized)'
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        new ArtworksSlider(el);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;